import { useQuery } from "@tanstack/react-query";
import { adminApi } from "../api/adminApi";

export function useAdminUsersQuery() {
  return useQuery({ queryKey: ["admin", "users"], queryFn: adminApi.listUsers });
}
